import './MiniOrder.scss';
import Component from './MiniOrder.js';
export default Component;
